export default {
    methods: {
        async sendMail({to, body, subject, projectId = 1, assets = [], attachments = [], attachmentNames = []}) {
            const data = {
                to,
                body,
                subject,
                projectId,
                assets,
                attachments,
                attachmentNames
            };

            let headers = new Headers({});
            headers.set('Content-Type', 'application/json')

            await fetch(window._settings.mailUrl, {
                method: "POST",
                body: JSON.stringify(data),
                headers
            })
        }
    }
}
